export default __webpack_public_path__ + "static/media/484.bf265139.jpg";